import styled from 'styled-components';
import { Grid, GridCell } from 'styles';

export const HorizontalScrollingContainer = styled(Grid)`
  grid-gap: 16px;
  overflow-x: scroll;

  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const ModuleContainer = styled(GridCell).attrs({
  columns: 4,
  padding: '16px',
  small: { columns: 1, width: '154px' },
})`
  border: 1px solid ${props => props.theme.colors.background.tertiary};
  border-radius: ${props => props.theme.borderRadii.large};
`;
